import VideoService from './VideoService'

export default VideoService
